<div class="flex flex-col gap-x-7.5 rounded-[10px] border border-malou-primary bg-white p-12 md:p-4">
    @if (partnerTheme()) {
        <!-- Partner layout -->
        <div class="flex justify-between md:gap-x-4">
            <div class="malou-text-34--bold font-futura-bt uppercase leading-[1.05] text-malou-text-title">
                {{
                    keywordsDiagnosticRating() === DiagnosticRating.GOOD
                        ? ('maloupe.diagnostic_result.keywords.title_partner.visible' | translate)
                        : ('maloupe.diagnostic_result.keywords.title_partner.not_visible' | translate)
                }}
            </div>
            <app-rating-chip [diagnosticRating]="keywordsDiagnosticRating()"></app-rating-chip>
        </div>
    } @else {
        <div class="flex justify-between md:gap-x-4">
            <div
                class="malou-text-34--bold md:malou-text-20--bold font-passion-one uppercase text-malou-text-title sm:w-9/12 md:leading-none"
                [innerHTML]="
                    keywordsDiagnosticRating() === DiagnosticRating.GOOD
                        ? ('maloupe.diagnostic_result.keywords.title.visible' | translate)
                        : ('maloupe.diagnostic_result.keywords.title.not_visible' | translate)
                "></div>
            <app-rating-chip [diagnosticRating]="keywordsDiagnosticRating()"></app-rating-chip>
        </div>
    }

    <mat-table class="malou-mat-table md:hidden" [trackBy]="trackByIdFn" [dataSource]="datasource()" #table="matTable">
        <ng-container matColumnDef="keywords">
            <mat-header-cell *matHeaderCellDef class="flex-2" mat-sort-header>
                {{ 'maloupe.diagnostic_keywords.keywords' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let keyword" class="flex-2">
                <span class="malou-text-13--semibold">{{ keyword.text }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="googlePosition">
            <mat-header-cell *matHeaderCellDef class="flex-4" mat-sort-header>
                {{ 'maloupe.diagnostic_keywords.google_position' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let keyword" class="flex-4">
                <div class="flex flex-col">
                    <ng-container [ngTemplateOutlet]="coreKeywordTemplate" [ngTemplateOutletContext]="{ keyword }"></ng-container>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="competitors">
            <mat-header-cell *matHeaderCellDef class="flex-0.5" mat-sort-header>
                {{ 'maloupe.diagnostic_keywords.competitors' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let keyword" class="flex-0.5 justify-center">
                <button
                    class="malou-text-13--bold italic"
                    [class.text-malou-primary]="!partnerTheme()"
                    [style.color]="partnerTheme()?.header?.primaryColor ?? null"
                    (click)="openKeywordsPositionModal(keyword)">
                    {{ 'common.view' | translate }}
                </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
            *matRowDef="let keyword; columns: displayedColumns; let i = index"
            [class.row-error]="keyword.rating === DiagnosticRating.VERY_BAD">
        </mat-row>
    </mat-table>
    <div class="hidden flex-col gap-y-2 md:mt-3 md:flex">
        @for (keyword of keywords(); track $index) {
            <div
                class="rounded-[10px] border border-malou-primary px-3 py-2"
                [class.row-error]="keyword.rating === DiagnosticRating.VERY_BAD">
                <div class="flex flex-col sm:gap-y-1">
                    <div class="malou-text-13--bold">
                        @if (keyword.text) {
                            {{ keyword.text | sentenceCase }}
                        } @else {
                            -
                        }
                    </div>
                    <ng-container [ngTemplateOutlet]="coreKeywordTemplate" [ngTemplateOutletContext]="{ keyword }"></ng-container>
                    <div>
                        <span class="malou-text-10--medium text-malou-text"
                            >{{ 'maloupe.diagnostic_keywords.competitors' | translate }} :
                        </span>
                        <button
                            class="malou-text-10--bold flex-0.5 italic"
                            [class.text-malou-primary]="!partnerTheme()"
                            [style.color]="partnerTheme()?.header?.primaryColor ?? null"
                            (click)="openKeywordsPositionModal(keyword)">
                            {{ 'common.view' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        }
    </div>
</div>

<ng-template let-keyword="keyword" #coreKeywordTemplate>
    @switch (keyword.rating) {
        @case (DiagnosticRating.GOOD) {
            <ng-container
                [ngTemplateOutlet]="positionRatingTemplate"
                [ngTemplateOutletContext]="{
                    icon: Icon.HEART_EYES_CAT,
                    title: keyword.displayedRating,
                    subtitle: 'maloupe.diagnostic_keywords.position_text.visible' | translate,
                }">
            </ng-container>
        }
        @case (DiagnosticRating.AVERAGE) {
            <ng-container
                [ngTemplateOutlet]="positionRatingTemplate"
                [ngTemplateOutletContext]="{
                    icon: Icon.SMILEY_CAT,
                    title: keyword.displayedRating,
                    subtitle: 'maloupe.diagnostic_keywords.position_text.visible' | translate,
                }">
            </ng-container>
        }
        @case (DiagnosticRating.BAD) {
            <ng-container
                [ngTemplateOutlet]="positionRatingTemplate"
                [ngTemplateOutletContext]="{
                    icon: Icon.CRYING_CAT_FACE,
                    title: keyword.displayedRating,
                    subtitle: 'maloupe.diagnostic_keywords.position_text.not_visible' | translate,
                }">
            </ng-container>
        }
        @default {
            <ng-container
                [ngTemplateOutlet]="positionRatingTemplate"
                [ngTemplateOutletContext]="{
                    icon: Icon.CRYING_CAT_FACE,
                    title: keyword.displayedRating,
                    subtitle: 'maloupe.diagnostic_keywords.position_text.not_visible' | translate,
                }">
            </ng-container>
        }
    }
</ng-template>

<ng-template let-icon="icon" let-title="title" let-subtitle="subtitle" #positionRatingTemplate>
    <div class="flex items-center gap-x-2">
        <img class="h-6 w-6 sm:h-4 sm:w-4" [alt]="icon" [src]="icon | imagePathResolver: { folder: 'icons' }" />
        <div class="flex flex-col sm:block sm:leading-none">
            <span class="malou-text-13--semibold sm:malou-text-10 text-color-text-title">{{ title }} </span>
            <span class="malou-text-11--regular sm:malou-text-10 text-color-text">{{ subtitle }}</span>
        </div>
    </div>
</ng-template>
